class ProductSizeGuide extends HTMLElement {
  constructor() {
    super();

    this.buttonToggleSize = this.querySelector('[product-size-guide-toggle]');

    this.bindEvents();
  }

  bindEvents() {
    this.buttonToggleSize.addEventListener('click', (event) => {
      this.toggleSize();
    });
  }

  toggleSize() {
    if (this.getAttribute('aria-selected') == 'cm') {
      this.setAttribute('aria-selected', 'inch');

      return;
    }

    this.setAttribute('aria-selected', 'cm');
  }
}

customElements.define('product-size-guide', ProductSizeGuide);
